
<form class="request-documentation-dialog" [formGroup]="newFormFG" (ngSubmit)="requestDocumentation()">
    <button mat-icon-button type="button" class="close-dialog-button" (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
    </button>
    <span class="dialog-title">
        Solicitar documentación
    </span>
    <span class="dialog-description">
        Aquí podrá diseñar un formulario personalizado para solicitar la documentación necesaria al cliente.
    </span>
    <mat-form-field class="garantor-form-field" appearance="outline">
        <mat-label>Descripción del formulario</mat-label>
        <textarea matInput formControlName="descripcion" rows="2"></textarea>
    </mat-form-field>
    <form class="field" *ngFor="let formGroup of camposArrayControls; let i = index" [formGroup]="formGroup">
        <span class="field-title">Campo {{i + 1}}</span>
        <div class="form-line">
            <mat-form-field class="garantor-form-field field-name-form-field" appearance="outline">
                <mat-label>Nombre del campo</mat-label>
                <input matInput formControlName="nombre">
                <mat-error *ngIf="formGroup.controls['nombre'].hasError('required')">
                    Por favor ingrese el nombre del campo
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field field-description-form-field" appearance="outline">
                <mat-label>Descripción</mat-label>
                <input matInput formControlName="descripcion">
            </mat-form-field>
            <mat-form-field class="garantor-form-field type-campo" appearance="outline">
                <mat-label>Tipo de campo</mat-label>
                <mat-select formControlName="tipo">
                    <mat-option *ngFor="let fieldType of fieldTypes" [value]="fieldType.codigo">
                        {{ fieldType.descripcion }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formGroup.controls['tipo'].hasError('required')">
                    Por favor seleccione el tipo de campo
                </mat-error>
            </mat-form-field>
            <button mat-icon-button type="button" class="delete-field-button" (click)="deleteField(i)">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </form>
    <div class="add-field agregar-campo" (click)="addField()" *ngIf="!newFormFG.disabled">
        <mat-icon>add_circle</mat-icon>
        Agregar campo
    </div>
    <button mat-raised-button color="primary" class="garantor-button solicitar-button">Solicitar documentación</button>
</form>
